import { useCallback, useState } from "react";
import { ConfirmWatchRequest, FlightAlertsService } from "../../../api/flightAlerts.service";
import { getDashErrorCode } from "./apiError.helper";
import { OtpOutcome } from "./useOtpSend";

export interface UseConfirmWatchResult {
  confirmWatch: (request: ConfirmWatchRequest) => Promise<OtpOutcome>;
  isConfirming: boolean;
}

export const useConfirmWatch = (): UseConfirmWatchResult => {
  const [isConfirming, setIsConfirming] = useState(false);

  const confirmWatch = useCallback(async (request: ConfirmWatchRequest): Promise<OtpOutcome> => {
    setIsConfirming(true);
    try {
      const service = new FlightAlertsService();
      await service.confirmWatch(request);
      return { success: true };
    } catch (err) {
      const errorCode = getDashErrorCode(err);
      return errorCode !== undefined ? { success: false, errorCode } : { success: false };
    } finally {
      setIsConfirming(false);
    }
  }, []);

  return { confirmWatch, isConfirming };
};
